import { useState, useEffect } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const initials = (name) =>
  (name || "?").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

// Circular account avatar: real photo (users/{id}/photo) with graceful initials fallback.
// `version` busts the cache after an upload/remove.
export const AccountAvatar = ({ id, name, hasPhoto, size = 36, version, className = "" }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [version, id]);
  const show = id && hasPhoto && !failed;
  const px = { width: size, height: size };
  if (show) {
    return (
      <img
        data-testid={`account-avatar-${id}`}
        src={`${BACKEND}/api/users/${id}/photo${version ? `?v=${version}` : ""}`}
        alt={name || "Account"}
        loading="lazy"
        onError={() => setFailed(true)}
        style={{ ...px, objectPosition: "center" }}
        className={`shrink-0 rounded-full object-cover ring-1 ring-black/5 ${className}`}
      />
    );
  }
  return (
    <span
      data-testid={`account-avatar-fallback-${id || "x"}`}
      style={{ ...px, fontSize: Math.round(size * 0.38) }}
      className={`grid shrink-0 place-items-center rounded-full bg-gradient-to-br from-[#D6E4F5] to-[#EDE9F5] font-semibold text-[#4A5568] ring-1 ring-black/5 ${className}`}
    >
      {initials(name)}
    </span>
  );
};

export default AccountAvatar;
